import(/* webpackMode: "eager" */ "/home/runner/work/aero-template-base/aero-template-base/apps/web/app/global-error.tsx");
